import { TeoEventTarget } from '@/teoCore/utility/TeoEventTarget';

export type LifecycleEvents<T> = {
  changed: (detail: { value: T; previousValue: T }) => void;
  destroyed: (currentValue: T) => void;
};

export class ReactiveValue<T> extends TeoEventTarget<LifecycleEvents<T>> {
  private value: T;
  private destroyed = false;

  constructor(value: T) {
    super();
    this.value = value;
  }

  get(): T {
    if (this.destroyed && __DEV__) {
      throw new Error('ReactiveValue is destroyed');
    }
    return this.value;
  }

  set(value: T) {
    if (this.destroyed && __DEV__) {
      throw new Error('ReactiveValue is destroyed');
    }
    const previousValue = this.value;
    this.value = value;
    this.triggerEvent('changed', { value, previousValue });
  }

  destroy() {
    this.triggerEvent('destroyed', this.value);
    this.destroyed = true;
    // free for garbage collection
    this.value = undefined as unknown as T;
    // TODO: remove all listeners
  }
}
